import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  getUser: function () {
    return axios.get(`${window.apiURL}api/user`)
  },
  login: function (username, password, captcha, lang) {
    return axios.post(`${window.apiURL}auth/login`, { username, password, captcha, lang })
  },
  logout: function () {
    return axios.get(`${window.apiURL}auth/logout`)
  },
  signUp: function (data) {
    return axios.post(`${window.apiURL}auth/register`, data)
  },
  facebookLogin: function (data) {
    return axios.post(`${window.apiURL}auth/facebook-login`, data)
  },
  googleLogin: function (data) {
    return axios.post(`${window.apiURL}auth/google-login`, data)
  },
  getCaptcha: function () {
    return axios.get(`${window.apiURL}auth/captcha`)
  },
  recover: function (email) {
    return axios.post(`${window.apiURL}auth/recover`, { username: email })
  },
  resendConfirmEmail: function (email) {
    return axios.post(`${window.apiURL}auth/resend-confirm`, {email: email})
  },
  confirmTwoFactor: function (code) {
    return axios.post(`${window.apiURL}auth/twofactor-confirm`, { code })
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.js